export const selectPrivacyKitDataMapping = (state) =>
  state.privacykitDataMapping;

export const selectPrivacyKitListDataMappingInventory = (state) =>
  state.privacykitDataMapping.listInventory;
